.az{position:absolute;}